import { forwardRef, useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import Button from 'style-guide/Button';
import Form from 'style-guide/Form';
import { Input } from 'style-guide/Input';

const SearchComponent = forwardRef(({ setVisible, field, handleSubmit, name, setFocus, visible }, ref) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const inputRef = useRef(null);

  const onFormSubmit = (formData) => {
    searchParams.set(name, formData[name].trim());
    setSearchParams(searchParams);
    setVisible(false);
  };

  useEffect(() => {
    if (visible) {
      inputRef.current?.focus({ preventScroll: true });
    }
  }, [visible]);

  const resetSearch = () => {
    if (searchParams.get(name)) {
      searchParams.delete(name);
      setSearchParams(searchParams);
    }
    field.onChange('');
    setFocus(name);
  };

  return (
    <Form onSubmit={handleSubmit(onFormSubmit)}>
      <div className='search-dropdown' ref={ref}>
        <Input {...field} ref={inputRef} />
        <div className='d-flex justify-content-between dropdown-buttons'>
          <Button variant='primary' type='submit' $block className='search-button'>
            Search
          </Button>
          <Button variant='secondary' $block onClick={resetSearch}>
            Reset
          </Button>
        </div>
      </div>
    </Form>
  );
});

export default SearchComponent;
